import { render, staticRenderFns } from "./i-smart-select.vue?vue&type=template&id=bdb0d580&scoped=true&"
import script from "./i-smart-select.vue?vue&type=script&lang=js&"
export * from "./i-smart-select.vue?vue&type=script&lang=js&"
import style0 from "./i-smart-select.vue?vue&type=style&index=0&id=bdb0d580&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb0d580",
  null
  
)

export default component.exports